<template>
    <div class="component-tasks-historic" v-if=loaded>
        <el-card class="box-card">
            <div slot="header" class="text-left">
                <h4 class="inline">Historic tasks</h4>
                <el-select
                    v-model="user"
                    filterable
                    collapse-tags
                    placeholder="User select"
                    @change="drawChart()"
                    class="fr"
                    v-if="getRoles().indexOf('1') !== -1 || getRoles().indexOf('4') !== -1"
                >
                    <el-option
                        v-for="user in $store.getters['general/getUsers']"
                        :key="user.user_id"
                        :label="user.first_name +' '+ user.last_name"
                        :value="user.user_id"
                    >
                    </el-option>
                </el-select>
            </div>
            <div class="chart-container" :id="'chart-container-historic-tasks'" style="position: relative; height: 350px; width:">
                <canvas id="historic-tasks"></canvas>
            </div>
        </el-card>
    </div>
</template>

<script>
import axios from '@/services/axios.js'
import { getHeadersWithAccessToken } from '../functions'
import { dataConvertDict } from '../chart/ChartData.js'
import ChartClass from '../chart/ChartClass.js'

export default {
    props: ['module'],
    data () {
        return {
            user: parseInt(localStorage.getItem('user_id')),
            chart: {},
            loaded: false
        }
    },
    methods: {
        tableRowClassName ({ row, rowIndex }) {
            if (Object.keys(row).includes('ticket_id')) {
                if (row.modified === false) {
                    return 'success-row'
                }
            }
        },
        getRoles () {
            return localStorage.getItem('roles').split(',')
        },
        drawChart () {
            axios.get(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_TICKET_API_BASE_URL_DEV : process.env.VUE_APP_TICKET_API_BASE_URL) + '/user_tickets?historic=true&user_id=' + this.user, { headers: getHeadersWithAccessToken() })
                .then(response => {
                    var ctx = document.getElementById('historic-tasks').getContext('2d')
                    let chartData = dataConvertDict['historic-tasks'](response.data.data)
                    if (Object.keys(this.chart).length > 0) {
                        this.chart.delete()
                    }
                    // Generate the chart
                    this.chart = new ChartClass(ctx, chartData['labels'], chartData['data'], chartData['scales'], chartData['type'], chartData['lineToday'])
                })
                .catch(error => {
                    console.log(error)
                })
        }
    },
    created () {
        this.$store.dispatch('general/getUsers').then(response => {
            this.drawChart()
            this.loaded = true
        })
    }
}
</script>

<style lang="scss">
.component-tasks-historic {
    .el-table .success-row {
        background: #e9f4f5;
    }
}
</style>
